<template>
	<FilterComponent
		:title="'IPCA'"
		:open="openFilter"
		:fields="filterFields"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
    />

	<Commonlisting
		:listingData="data"
		:headersData="headers"
		:headerInfo="headerInfo"
		:inputsListing="inputs"
		:previous="previous"
		:next="next"
		:currentPage="currentPage"
		:totalPages="totalPages"
		:totalRecords="totalRecords"
		:resetFormData="resetFormData"
		:editFormData="editFormData"
		:importFile="false"
		:useForms="true"
		:fileOnly="false"
		@previous-page="pageData"
		@next-page="pageData"
		@go-to-page="goTo"
		@delete-data-id="deleteData"
		@send-form-data="onSendFormData"
		@edit-confirmation="getEditData"
		@send-editing-data="onSendEditingData"
		@filter="openFilter = true"
	/>

	<CommonLoading v-if="loading" />
</template>

<script>
import Commonlisting from '@/components/generalcomponents/CommonListing.vue';
import IndiceIpcaRepository from '@/services/IndiceIpcaRepository.vue';
import { pageVariables } from '@/views/insideviews/indice_ipca/PageVariablesIndiceIpca.js';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";
import Swal from "sweetalert2";
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';

export default {
	name: 'IndicesIpcaView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.indicesIpcaGetPage);
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			editFormData:{},
			openFilter: false,
			filters: [],
			loading: false,
			filterFields: [
				{
					name: "mes_ano",
					label: "Mês/Ano",
					type: "month",
					placeholder: "Busque pelo mês/ano"
				}
			]
		};
	},
	methods: {
		async pageData(page){
			this.loading = true; 
			const repo = new IndiceIpcaRepository();
			try {
                let searchQuery = '';
                if(this.filters && this.filters.length > 0) {
                    const mesAnoFilter = this.filters.find(f => f.name === 'mes_ano');
                    if (mesAnoFilter) searchQuery = mesAnoFilter.value;
                }

				const response = await repo.getIndicesIpca(this.onlineUser.token, page, searchQuery);
				if (response?.status === 200) {
					this.data = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;
					this.next = response.data.next_page_url || "";
					this.previous = response.data.prev_page_url || "";
				}
			} catch (error) {
				handleUnauthorized(error);
			} finally {
				this.loading = false; 
			}
		},
		async onSendFormData(data){
			this.loading = true; 
			const repo = new IndiceIpcaRepository();
			try {
				const response = await repo.createIndiceIpca(this.onlineUser.token, data);
				if (response?.status === 201 || response?.status === 200) {
					this.pageData(this.indicesIpcaGetPage);
					this.resetForm();
					this.mostrarAlerta();
				} else {
					this.mostrarAlertaErro(response?.message);
				}
			} catch (error) {
				handleUnauthorized(error);
			} finally {
				this.loading = false; 
			}
		},
		async onSendEditingData(data, id){
			this.loading = true; 
			const repo = new IndiceIpcaRepository();
			try {
				const response = await repo.updateIndiceIpca(this.onlineUser.token, id, data);
				if (response?.status === 200) {
					this.pageData(this.indicesIpcaGetPage);
					this.mostrarAlerta();
				} else {
					this.mostrarAlertaErro(response?.message);
				}
			} catch (error) {
				handleUnauthorized(error);
			} finally {
				this.loading = false; 
			}
		},
		async deleteData(id){
			this.loading = true; 
			const repo = new IndiceIpcaRepository();
			try {
				const response = await repo.deleteIndiceIpca(this.onlineUser.token, id);
				if (response?.status === 200 || response?.status === 204) {
					this.pageData(this.indicesIpcaGetPage);
					this.mostrarAlerta();
				} else {
					this.mostrarAlertaErro(response?.message);
				}
			} catch (error) {
				handleUnauthorized(error);
			} finally {
				this.loading = false; 
			}
		},
		async getEditData(id){
            const selected = this.data.find(d => d.id === id);
            if(selected) {
                let editData = JSON.parse(JSON.stringify(selected));
                if(editData.mes_ano && editData.mes_ano.length > 7) {
                    editData.mes_ano = editData.mes_ano.substring(0, 7);
                }
                this.editFormData = editData;
            }
		},
		goTo(number){
			this.pageData(this.indicesIpcaGetPage+"?page="+number);
		},
		handleFilters(rawFilters){
			this.filters = rawFilters;
			this.openFilter = false;
			this.pageData(this.indicesIpcaGetPage);
		},
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		},
		mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6', 
			});
		},
		mostrarAlertaErro(message) {
			Swal.fire({
				icon: 'error',
				title: 'Erro!',
				text: message || 'Ocorreu um erro durante a operação.',
				confirmButtonColor: '#3085d6', 
			});
		}
	},
	components:{
		Commonlisting,
		FilterComponent,
		CommonLoading
	}
}
</script>

<style scoped>
</style>
